import { DictionariesDemoPage } from "@/features/dictionaries/components/DictionariesDemoPage";
import { useNav } from "@/utils/nav";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/design/components/dictionaries")({
    component: DictionariesPage,
});

function DictionariesPage() {
    useNav([
        { label: "Design", route: { to: "/design" } },
        { label: "Dictionaries", route: { to: "/design/components/dictionaries" } },
    ]);

    return <DictionariesDemoPage />;
}
